/// Modal-livscyklus per FR-MOD-01..05. Open + close-by-id, plus globale
/// dismissal-mekanismer (Escape + overlay-click). En enkelt instans pr.
/// dokument; subscribes ved konstruktion.

export interface IModalService {
  open(id: string): void;
  close(id: string): void;
  closeTopmost(): void;
}

export class ModalService implements IModalService {
  constructor(private readonly doc: Document = document) {
    this.installGlobalListeners();
  }

  open(id: string): void {
    this.doc.getElementById(id)?.classList.add('active');
  }

  close(id: string): void {
    this.doc.getElementById(id)?.classList.remove('active');
  }

  closeTopmost(): void {
    const open = this.doc.querySelector<HTMLElement>('.modal-overlay.active');
    open?.classList.remove('active');
  }

  private installGlobalListeners(): void {
    // Escape lukker øverste åbne modal (FR-MOD-01 + FR-A11Y-06).
    this.doc.addEventListener('keydown', (e: KeyboardEvent) => {
      if (e.key === 'Escape') this.closeTopmost();
    });

    // Klik på selve overlay'et (uden for modal-boksen) lukker også.
    this.doc.addEventListener('click', (e: MouseEvent) => {
      const target = e.target as HTMLElement | null;
      if (target?.classList.contains('modal-overlay')) {
        target.classList.remove('active');
      }
    });
  }
}
